import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";

export const SOCIAL_LINKS = [
  {
    id: "github",
    label: "GitHub",
    href: "https://github.com/MarioGoDevLike",
    Icon: FaGithub,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://LinkedIn.com/in/mario-nassar",
    Icon: FaLinkedin,
  },
  {
    id: "instagram",
    label: "Instagram",
    href: "https://Instagram.com/marionasssar",
    Icon: FaInstagram,
  },
];
